"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const error_messages_1 = require("@Const/error-messages");
const react_hook_form_1 = require("react-hook-form");
const FieldErrorSectionForm = (props) => {
    const formState = (0, react_hook_form_1.useFormState)();
    const { assistiveText, required, visibility = { errors: true, assistive: true }, name } = props;
    const error = (0, react_hook_form_1.get)(formState.errors, name);
    return (react_1.default.createElement(react_1.default.Fragment, null, error && visibility.errors ? (react_1.default.createElement("p", { className: "error-text small" }, error.message)) : (react_1.default.createElement(react_1.default.Fragment, null, visibility.assistive && (react_1.default.createElement("p", { className: "assistive-text small" }, assistiveText ? assistiveText : required ? error_messages_1.REQUIRED_MESSAGE : 'Optional'))))));
};
exports.default = FieldErrorSectionForm;
